module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-07.98134c1e.jpg";